module.exports = __webpack_public_path__ + "static/media/MeetMe.7a00b4fe.png";